module.exports = __webpack_public_path__ + "static/img/BG.17814487.svg";